var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('LmFormBuilder',{attrs:{"endpointUriwhereGetComponents":`formbuilder/${_vm.$route.params.idFormBuilder}`,"endpointUriWhereGetValuesToLoadInEditMode":_vm.fullEndpointUriToGetFormValues}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }